import { whiteListConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const whiteUserActions = {
    searchWhiteList,
};

function searchWhiteList(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: whiteListConstants.SEARCH_WHITELIST_REQUEST,
            data: null
        }));
        adminUsersServices.searchWhite(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: whiteListConstants.SEARCH_WHITELIST_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: whiteListConstants.SEARCH_WHITELIST_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: whiteListConstants.SEARCH_WHITELIST_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}